<template>
  <div class="Reports__Import__View">
    <h1>עדכון אורכים ותמונות חסרות לוידאו</h1>
    <div class="Reports__Import__View__Steps">
      <div class="loading">
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
      </div>
      <div>
        <b-field label="עדכון אורכים חסרים לוידאו">
          <div class="input-section">
            <div>
              <label for="from-course">מקורס:</label>
              <select v-model="durationFromCourseId">
                <option v-for="course in courses" :value="course.id">{{ course.name }}</option>
              </select>
            </div>
            <b-button style="width: 200px;" @click="updateVideosDuration">
              עדכון
            </b-button>
          </div>
        </b-field>
      </div>
      <div>
        <b-field label="עדכון אורך לסרטון בודד">
          <input type="number" v-model="videoId" placeholder="מספר הסרטון">
          <b-button @click="updateVideoDuration">עדכון</b-button>
        </b-field>
      </div>
      <div>
        <b-field label="עדכון תמונות חסרות לוידאו">
          <div class="input-section">
            <div>
              <label for="from-course">מקורס:</label>
              <select v-model="thumbnailFromCourseId">
                <option v-for="course in courses" :value="course.id">{{ course.name }}</option>
              </select>
            </div>
            <b-button style="width: 200px;" @click="updateVideosThumbnails">
              עדכון
            </b-button>
          </div>
        </b-field>
      </div>
      <div>
        <b-field label="עדכון תמונה לסרטון בודד">
          <input type="number" v-model="videoThumbnailId" placeholder="מספר הסרטון">
          <b-button @click="updateVideoThumbnail">עדכון</b-button>
        </b-field>
      </div>
    </div>
  </div>
</template>
<script>
import { ToastProgrammatic as Toast } from "buefy";
import AdminService from '@/services/AdminService';
const BASE_URL = process.env.VUE_APP_APIURL;

export default {
  components: {},
  name: 'AdminImportCreate',
  data() {
    return {
      isLoading: false,
      videoId: null,
      videoThumbnailId: null,
      durationFromCourseId: null,
      thumbnailFromCourseId: null,
      courses: null

    };
  },
  computed: {
  },
  created() {
    this.$api.get(BASE_URL + '/api/Courses')
      .then((data) => {
        data.data.unshift({ id: null, name: 'בחר קורס' });
        this.courses = data.data;
      }).catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    updateVideosDuration() {
      this.isLoading = true;
      AdminService.updateVideosDuration(this.durationFromCourseId)
        .then(() => {
          Toast.open({
            type: "is-success",
            message: "העדכון בוצע בהצלחה!",
            duration: 8000,
          });
        }).catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה.",
            duration: 8000,
          });
        }).finally(() => {
          this.isLoading = false;
        });
    },
    updateVideoDuration() {
      if (!this.videoId) return;
      this.isLoading = true;
      AdminService.updateVideoDuration(this.videoId)
        .then(() => {
          Toast.open({
            type: "is-success",
            message: "העדכון בוצע בהצלחה!",
            duration: 8000,
          });
        }).catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה.",
            duration: 8000,
          });
        }).finally(() => {
          this.isLoading = false;
        });
    },
    updateVideosThumbnails() {
      this.isLoading = true;
      AdminService.updateVideosThumbnails(this.thumbnailFromCourseId)
        .then(() => {
          Toast.open({
            type: "is-success",
            message: "העדכון בוצע בהצלחה!",
            duration: 8000,
          });
        }).catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה.",
            duration: 8000,
          });
        }).finally(() => {
          this.isLoading = false;
        });
    },
    updateVideoThumbnail() {
      if (!this.videoThumbnailId) return;
      this.isLoading = true;
      AdminService.updateVideoThumbnails(this.videoThumbnailId)
        .then(() => {
          Toast.open({
            type: "is-success",
            message: "העדכון בוצע בהצלחה!",
            duration: 8000,
          });
        }).catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה.",
            duration: 8000,
          });
        }).finally(() => {
          this.isLoading = false;
        });
    }
  },
  watch: {},
};
</script>
<style scoped lang="scss">
.Reports__Import__View h1 {
  font-size: 25px;
  padding: 25px 25px 0 0;
}

.input-section {
  display: flex;
  flex-direction: column;
}

.Reports__Import__View__Steps {
  padding: 50px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-content: center;

  ::v-deep .step-content {
    padding: 60px 0 10px 0;
  }

  section {
    width: 100%;
  }

  .ChooseFile__Step {
    display: flex;
    flex-direction: column;
    justify-items: center;
    padding: 30px 0;
    width: 600px;
    margin: 0 auto;

    ::v-deep {

      .field,
      .file {
        text-align: center;
        justify-content: center;
      }
    }
  }

  .Progress__Step {
    width: 600px;
    padding: 30px 0;
    margin: 0 auto;
  }

  ::v-deep {

    .b-steps .steps .step-items .step-item:not(:first-child)::before,
    .b-steps .steps .step-items .step-item:only-child::before {
      right: -50%;
      left: unset;
    }

    .b-steps .steps .step-items .step-item::before,
    .b-steps .steps .step-items .step-item::after {
      background-position: left bottom;
      background: linear-gradient(to right, #dbdbdb 50%, #7957d5 50%);
      background-size: 200% 100%;
    }

    .b-steps .steps .step-items .step-item.is-active::before,
    .b-steps .steps .step-items .step-item.is-active::after {
      background-position: right bottom;
    }

    .b-steps .steps .step-items .step-item.is-previous::before,
    .b-steps .steps .step-items .step-item.is-previous::after {
      background-position: right bottom;
    }
  }

  .TollRoads__Import__View__Steps__Navigations {
    display: flex;
    justify-content: center;

    ::v-deep button {
      margin: 0 5px;
    }
  }
}

::v-deep {
  .top.level {
    flex-direction: row-reverse;
  }

  .pagination.is-simple {
    flex-direction: row-reverse;
  }

  .b-table .table-wrapper.has-sticky-header {
    height: calc(100vh - 485px);
    overflow-y: auto;
  }
}

.starting-row {
  width: 300px;
  margin-bottom: 10px;
  display: flex;
  align-items: self-end;

  .field:not(:last-child) {
    margin-bottom: 0;
  }
}

.switch {
  direction: ltr;
}

.settings-step {
  width: 500px;
}

.importing-step {
  height: 500px;
}

.status-step {

  .table {
    width: 100%;
    margin-top: 30px;

    tbody tr {
      background-color: #daffda;
    }
  }

  .has-error {
    background-color: #ffdada !important;
  }
}

::v-deep .table.is-hoverable tbody tr:not(.is-selected):hover {
  background-color: #eaf0f6 !important;
  cursor: pointer;
}

::v-deep .table.is-striped tbody tr:not(.is-selected):nth-child(even) {
  background-color: #efefef;
}
</style>
